import numeral from "numeral";

// ----------------------------------------------------------------------

export function fCurrency(number: string | number) {
  return numeral(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}

export function fPercent(number: number) {
  return numeral(number / 100).format("0.0%");
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return numeral(number).format("0.00a").replace(".00", "");
}

export function fData(number: string | number) {
  return numeral(number).format("0.0 b");
}

export const toOrdinal = (n: number) => {
  var s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const checkIfNumber = (value: any) => {
  return (
    typeof value === "number" || (typeof value === "string" && !isNaN(+value))
  );
};

export const convertToNumber = (value: any) => {
  return checkIfNumber(value) ? +value : value;
};
